import template from './project-browser.template.html';
import {ProjectBrowserController} from "./project-browser.controller";

export class ProjectBrowserService {

    constructor($log, $uibModal) {
        'ngInject';

        this.$log = $log;
        this.$uibModal = $uibModal;

    }

    open() {

        let modalInstance = this.$uibModal.open({
            templateUrl: template,
            controller: ProjectBrowserController,
            controllerAs: '$ctrl'
        });

        return modalInstance
            .result
            .then(function (result) {
                return result;
            });

    }

}



// WEBPACK FOOTER //
// ./src/js/components/project-browser/project-browser.service.js